import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_ORGANIZATION_INFO);
var axios_instance_org = get_axios_instance(api_variables.SERVICE_FAVOURITE_ORG);
var axios_filter_instance_org = get_axios_instance(api_variables.SERVICE_FILTER_ORG);
var axios_instance_make_org_fav_unfav = get_axios_instance(api_variables.SERVICE_MAKE_ORGANISATION_FAV_UNFAV);
var axios_instance_get_org_le_list = get_axios_instance(api_variables.SERVICE_GET_ORG_LEGAL_LIST);

const _pk_name = "id";

const state = {
    data: [],
    allOrgsData: {},
    id: '',
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    isFavourite: false,
    permissions: [],
    home_le_id: ""
};

const getters = {
    orgnizationData: (state) => {
        return state.data;
    },
    organizationID: (state) => {
        return state.id;
    }
};
const mutations = {
    set: (state, payload) => {
        state.data = payload;
    },
    setAllOrgsData: (state, payload) => {
        state.allOrgsData = payload;
    },
    addEntity: (state, payload) => {
        state.data = [payload];
    },

    updateEntityById: (state, payload) => {
        state.data = [payload]
    },
    removeEntityById: (state, payload) => {
        for (let i = 0; i < state.data.length; i++) {
            if (state.data[i][_pk_name] == payload) {
                state.data.splice(i, 1);
            }
        }
    },
    setOrgId: (state, id) => {
        state.id = id;
    },
    setOrgType: (state, isFavourite) => {
        state.isFavourite = isFavourite;
    },
    setFetching: (state, payload) => {
        state.isFetching = payload;
    },
    setSaving: (state, payload) => {
        state.isSaving = payload;
    },
    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },
    getpermissions: (state, payload) => {
        state.permissions = payload;
    },
    homeLeId: (state, payload) =>{
        state.home_le_id = payload;
    }
}

const updateToken = () => {
    let token = localStorage.getItem('token') ? localStorage.getItem('token').replace(/(^"|"$)/g, '') : "";
    axios_instance_org.defaults.headers['Authorization'] = `Bearer ${token}`;
}

const updateFetchToken = () => {
    let token = localStorage.getItem('token') ? localStorage.getItem('token').replace(/(^"|"$)/g, '') : "";
    axios_instance.defaults.headers['Authorization'] = `Bearer ${token}`;
}

const actions = {
    async fetchAll({ commit }, payload) {
        try {
            updateFetchToken();
            commit("setFetching", true);
            let res = await axios_instance.get(`/${payload}`);
            commit("setFetching", false);
            if (res.status == 200) {
                //console.log('in commit set mutation',res.data.payload)
                commit("set", res.data.payload.data); //todo: Check for Pagination
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);

        }
    },
    async fetchFavouriteOrg({ commit }, payload) {
        try {
            updateToken();
            commit("setFetching", true);
            let res = await axios_instance_org.get(``);
            commit("setFetching", false);
            if (res.status == 200) {
                commit("setAllOrgsData", res.data.payload);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async searchFavouriteOrg({ commit }, payload) {
        try {
            let res = await axios_filter_instance_org.get(``, { params: { key: payload } });
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async create({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.post('/', payload);
            commit("setSaving", false);
            if (res.status == 200 || res.status == 201) {
                commit("setOrgId", res.data.payload.id);
                commit("addEntity", res.data.payload);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async update({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.put(`/${payload.data.id}`, payload);
            commit("setSaving", false);
            if (res.status == 200 || res.status == 201) {
                commit("setOrgId", res.data.payload.id);
                commit("updateEntityById", res.data.payload);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async changeOrgId({ commit }, payload) {
        try {
            commit("setOrgId", payload);
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async changeOrgType({ commit }, payload) {
        try {
            commit("setOrgType", payload);
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async setHomeLeId({ commit }, payload) {
        try {
            commit("homeLeId", payload);
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async markOrganisationAsFavOrUnFav({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance_make_org_fav_unfav.post(`?email=${payload.data.email}&mark=${payload.data.isFavourite}`, payload);
            commit("setSaving", false);
            if (res.status == 200 || res.status == 201) {
                commit("setOrgType", payload.data.isFavourite);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async getOrgLeIdList({ commit }, payload) {
        //console.log("[state/payroll/fbp/assign/fetchAll] Calling API...");
        //console.log("Payload data", payload);
        try {
            commit("getpermissions", payload);
            let res = await axios_instance_get_org_le_list.post('/', 
                payload
              );
            //console.log("[state/payroll/fbp/assign/fetchAll] resssss: ", res);
            if (res.status == 200) {
                commit("getpermissions", res);
            }
            return res;
        } catch (err){
          //console.log(err);
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}